import {
  getTenantId,
  // getToken,
  removeToken,
  removeTenantId,
  removeRoleCode,
  removeUserId,
  removeLoginSentryId,
  setLastLoginTime,
} from "@/utils/service";
import { getTenantList, queryUserSch } from "@/api/module/tenant";
import { toLogout, getUserInfo } from "@/api/module/login";
// import router from "../../router/index";
import Store from "../index";
const user = {
  state: {
    isManager: false, // 是否是客服人员
    isParkingLot: false, // 是否是车场管理员
    isTollcollector: false, // 是否是车场收费员
    userInfo: {},
    tenantId: 0,
    tenantList: [],
    userName: "", //用户姓名
    isCashier: false, // 登录时商户角色是不是收费员cashier
    isWorkTime: false, //是否是工作时间
    isTenantAdmin: false,
    isReLogin: 0,//是否重复登录
    isSentryStatement: false,
    settingNotice: '',
  },
  mutations: {
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo;
    },
    SET_TENANTID: (state, tenantId) => {
      state.tenantId = Number(tenantId);
    },
    SET_TENANTLIST: (state, list) => {
      state.tenantList = list;
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName;
    },
    SET_ISCASGHIER: (state, isCashier) => {
      state.isCashier = isCashier === "sentryBox";
      state.isTenantAdmin = isCashier === "tenantAdmin";
    },
    SET_ISWORKTIME: (state, isWorkTime) => {
      state.isWorkTime = isWorkTime;
    },
    SET_ISMANAGER: (state, isManager) => {
      state.isManager = isManager;
    },
    SET_ISRELOGIN: (state, isReLogin) => {
      state.isReLogin = isReLogin;
    },
    SET_IsSentryStatement: (state, isSentryStatement) => {
      state.isSentryStatement = isSentryStatement;
    },
    SET_SettingNotice: (state, settingNotice) => {
      state.settingNotice = settingNotice;
    },
  },
  actions: {
    SetUserInfo: ({ commit }, userinfo) => {
      return new Promise((resolve) => {
        let isManager = userinfo.Role.RoleCode === "manager" || userinfo.Role.RoleCode === "managerGate";
        commit("SET_USERINFO", userinfo);
        commit("SET_ISMANAGER", isManager);
        let tenantId = 0;
        commit("SET_TENANTID", tenantId);
        if (isManager) {
          getTenantList({
            Page: 1,
            PerPage: 1000,
            TenantUserId: userinfo.Id,
          }).then((res) => {
            if (getTenantId()) {
              tenantId = getTenantId();
            } else {
              if (res.state === "success") {
                tenantId = res.data[0].Id;
              }
            }
            commit("SET_TENANTLIST", res.data);
            commit("SET_TENANTID", tenantId);
            resolve();
          });
        } else {
          tenantId = userinfo.TenantId;
          commit("SET_TENANTID", tenantId);
          resolve();
        }
      });
    },
    SetTenantId: ({ commit }, tenantId) => {
      commit("SET_TENANTID", tenantId);
    },
    // 获取用户信息
    GetUserInfo: () => {
      return new Promise((resolve) => {
        getUserInfo()
          .then((res) => {
            if (res.state === "success") {
              //    commit('setUserInfo',res.data);
              Store.dispatch("SetUserInfo", res.data);
              setLastLoginTime(res.data.LastLoginTime);
              sessionStorage.setItem('lastRefreshTimeNode', new Date().getTime());
            }
            resolve(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    LogOut: () => {
      toLogout().then(() => {
        removeToken();
        removeTenantId();
        removeRoleCode();
        removeUserId();
        removeLoginSentryId();
        Store.dispatch("SetUserName", '');
        sessionStorage.clear();
        window.location.reload();
        // router.push("/login");
      });
    },
    SetUserName: ({ commit }, userName) => {
      commit("SET_USERNAME", userName);
    },
    SetIsCashier: ({ commit }, roleCode) => {
      commit("SET_ISCASGHIER", roleCode);
    },
    GetWorkTime: () => {
      //请求工作时间段接口
      let date = new Date();
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      let time = `${h}:${m}:${s}`;
      queryUserSch({Id:Store.state.user.userInfo.Id}).then(res => {
        let isWorkData = res.data.find(v=>{
          return time >=v.StartAt && time <= v.EndAt
        });
        let isWorkTime = isWorkData !== undefined;
        Store.dispatch("SetIsWorkTime", isWorkTime);
      })
    },
    SetIsWorkTime: ({ commit }, isWorkTime) => {
      commit("SET_ISWORKTIME", isWorkTime);
    },
    SetIsReLogin: ({ commit }, isReLogin) => {
      commit("SET_ISRELOGIN", isReLogin);
    },
    SetIsSentryStatement: ({ commit }, isSentryStatement) => {
      commit("SET_IsSentryStatement", isSentryStatement);
    },
    SetSettingNotice: ({ commit }, settingNotice) => {
      commit("SET_SettingNotice", settingNotice);
    },
  },
};
export default user;
